import AuthRoutes from "@cms/features/Auth/AuthRoutes";
import { ClientRoutes } from "@cms/features/Clients/ClientsRoutes";
import { DashboardsRoutes } from "@cms/features/Dashboards/DashboardsRoutes";
import { PriceCalculatorRoutes } from "@cms/features/PriceCalculator/PriceCalculatorRoutes";
import { SettingsRoutes } from "@cms/features/Settings/SettingsRoutes";
import { useAuthStore } from "@verbleif/shared/src/composables/AuthStore/useAuthStore";
import { createCmsAutomationRoutes } from "@verbleif/shared/src/composables/Automation/automationRoutes";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  ...ClientRoutes,
  ...SettingsRoutes,
  ...createCmsAutomationRoutes(() => import("@verbleif/shared/src/composables/Automation/AutomationContainer.vue")),
  ...DashboardsRoutes,
  ...PriceCalculatorRoutes,
  ...AuthRoutes,
];
const { returnUrl, hasToken, isRemembered } = useAuthStore();

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});
export default router;

router.beforeEach((to) => {
  if (to.meta.skipAuthChecks) {
    return true;
  }

  const isUnauthenticated = !hasToken.value && !isRemembered.value;
  // const isAuthenticated = hasToken.value || isRemembered.value;

  if (isUnauthenticated && !to.meta.public) {
    returnUrl.value = to.fullPath;
    return { name: "login" };
  }

  if (to.meta.public) {
    return true;
  }

  // if (isAuthenticated && !isAdmin.value) {
  //   return { name: "404" };
  // }

  return true;
});
